// src/pages/RunwayVideoGenerator.jsx
import React, { useState } from "react";
import { generateVideoFromImage } from "./generateVideoFromImage";

export default function RunwayVideoGenerator() {
  const [prompt, setPrompt] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [videoUrl, setVideoUrl] = useState("");
  const [loading, setLoading] = useState(false);

  const handleGenerate = async () => {
    if (!imageUrl || !prompt) {
      return alert("이미지 URL과 프롬프트를 입력해주세요");
    }
    setLoading(true);

    try {
      const result = await generateVideoFromImage(imageUrl, prompt);
      if (result?.outputs?.[0]?.video) {
        setVideoUrl(result.outputs[0].video);
      } else {
        alert("영상 생성 실패 또는 응답 없음");
      }
    } catch (err) {
      console.error("영상 생성 에러:", err);
      alert("영상 생성 중 오류 발생");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-xl mx-auto p-6 space-y-6">
      <h1 className="text-2xl font-bold">Runway 영상 생성기</h1>

      <input
        type="text"
        value={imageUrl}
        onChange={(e) => setImageUrl(e.target.value)}
        placeholder="이미지 URL을 입력하세요"
        className="border p-2 w-full"
      />

      <textarea
        value={prompt}
        onChange={(e) => setPrompt(e.target.value)}
        placeholder="영상에 적용할 프롬프트 입력"
        className="border p-2 w-full h-24"
      />

      <button
        onClick={handleGenerate}
        className="bg-blue-600 text-white px-4 py-2 rounded"
        disabled={loading}
      >
        {loading ? "생성 중..." : "영상 생성"}
      </button>

      {videoUrl && (
        <video
          src={videoUrl}
          controls
          autoPlay
          className="w-full mt-4 border"
        />
      )}
    </div>
  );
}
